import { DiagnosticReportImportedAction, IMPORTED_DIAGNOSTIC_REPORT } from '../actions/diagnostic_report_imported'

export default function diangosticReportImported(diagnosticReportImported: boolean = false, action: DiagnosticReportImportedAction) {
  switch (action.type) {
  case IMPORTED_DIAGNOSTIC_REPORT:
    return true
  default:
    return diagnosticReportImported
  }
}